import React from 'react';
import MetricaBase from './MetricaBase';

const MetricaDeficiencia = () => {
  return (
    <MetricaBase
      titulo="Colaboradores com Deficiência"
      descricao="Análise de colaboradores ativos com e sem deficiência"
      endpoint="deficiencia"
      tipoDownload="deficiencia"
      cor="red"
      mostrarGraficoArea={false}
    />
  );
};

export default MetricaDeficiencia;